<template>
<div class="arrival-admin">
    <div class="title">
        催交管理
    </div>
    
    <div class="search-box">
        <el-form :inline="true" :model="searchData" size="mini">
            <!-- <el-form-item label="用户名">
                <el-input v-model="searchData.member_name" placeholder="请输入用户名" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="企业名">
                <el-input v-model="searchData.store_name" placeholder="请输入企业名" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产编码">
                <el-input v-model="searchData.sccode" placeholder="请输入生产编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="OE号">
                <el-input v-model="searchData.oecode" placeholder="请输入OE号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">搜索</el-button>
                <el-button @click="clearSearch">清空</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="urge-table">
        <div class="table-head">
            <div class="index">序号</div>
            <div class="member_name">用户名</div>
            <div class="store_name">企业名</div>
            <div class="goods_name">配件名称</div>
            <div class="sccode">生产编码</div>
            <div class="oecode">OE号</div>
            <div class="oenaturebrand">品牌</div>
            <!-- <div class="arrived_state">状态</div> -->
            <div class="add_time">催交时间</div>
            <div class="add_time">操作</div>
        </div>
        <div class="table-body">
            <div class="table-row" v-for="(item, index) in urgeList" :key="index">
                <div class="index">{{ index + 1 }}</div>
                <div class="member_name">{{ item.member_name }}</div>
                <div class="store_name">{{ item.new_store_name }}</div>
                <div class="goods_name" :title="item.goods_name">{{ item.goods_name }}</div>
                <div class="sccode">{{ item.sccode }}</div>
                <div class="oecode">{{ item.oecode }}</div>
                <div class="oenaturebrand">{{ item.oenaturebrand }}</div>
                
                <div class="add_time">{{ $hnwTools.formatDateTime(item.addtime) }}</div>
                <div class="add_time">
                    <el-input v-model="item.arrivalTime" @blur="handleArrivalTimeBlur(item)" placeholder="请输入到货时间"></el-input>
                    <el-input  v-model="item.arrivalRemake" type="primary" @click="handleArrivalTimeBlur(item)"  placeholder="请输入延期备注"></el-input>
                </div>
            </div>
            <div v-if="urgeList.length === 0" class="no-data">
                暂无数据
            </div>
        </div>
    </div>
    
    <div class="pagination-box" v-if="total > 0">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            searchData: {
                member_name: '',
                store_name: '',
                sccode: '',
                oecode: ''
            },
            urgeList: [],
            total: 0,
            currentPage: 1,
            pageSize: 20
        };
    },
    methods: {
        async getUrgeList(params = {}) {
            try {
                let searParams = {
                    curpage: this.currentPage,
                    page: this.pageSize,
                    ...params
                };
                
                let res = await this.$api.select_goods_urge(searParams);
                
                if (res && res.list) {
                    this.urgeList = res.list;
                    this.total = Number(res.total) || 0;
                } else {
                    this.urgeList = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('获取催交列表失败:', error);
                this.$message.error('获取催交列表失败');
            }
        },
        async handleArrivalTimeBlur(item) {
            console.log(item.arrivalTime);
       
            let res = await this.$axios({
                method: 'post',
                headers:{
                    'content-type':'application/json'
                },
                url:"https://test.huanuowei.cn/api/mation/index.php?act=parts&op=batchUpdate",
                data:{
                    data:JSON.stringify([{
                        goods_id:item.goods_id,
                        data:{
                            arrivalTime:item.arrivalTime,
                            sh_buy_status:item.sh_buy_status,
                        }
                    }])
                }
            })
        },
        
        onSubmit() {
            this.currentPage = 1;
            this.getUrgeList({
                member_name: this.searchData.member_name,
                store_name: this.searchData.store_name,
                sccode: this.searchData.sccode,
                oecode: this.searchData.oecode
            });
        },
        
        clearSearch() {
            this.searchData = {
                member_name: '',
                store_name: '',
                sccode: '',
                oecode: ''
            };
            this.currentPage = 1;
            this.getUrgeList({});
        },
        
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getUrgeList({
                member_name: this.searchData.member_name,
                store_name: this.searchData.store_name,
                sccode: this.searchData.sccode,
                oecode: this.searchData.oecode
            });
        }
    },
    created() {
        this.getUrgeList({});
    }
};
</script>

<style lang="scss">
.arrival-admin {
    padding: 20px;
    background: #f5f5f5;
    min-height: 100%;
    
    .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e4e4;
    }
    
    .search-box {
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        margin-bottom: 15px;
        
        .el-form-item {
            margin-bottom: 0;
        }
        
        .el-input {
            width: 180px;
        }
    }
    
    .urge-table {
        background: #fff;
        border-radius: 4px;
        
        .table-head {
            display: flex;
            background: #c4c9cc;
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
            
            > div {
                text-align: center;
                font-size: 14px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .index { width: 60px; }
            .member_name { width: 100px; }
            .store_name { width: 150px; }
            .goods_name { flex: 1; min-width: 150px; }
            .sccode { width: 120px; }
            .oecode { width: 120px; }
            .oenaturebrand { width: 100px; }
            .arrived_state { width: 90px; }
            .add_time { width: 160px; }
        }
        
        .table-body {
            .table-row {
                display: flex;
                padding: 0 10px;
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #e4e4e4;
                
                &:nth-child(2n) {
                    background: #f7f7f7;
                }
                
                > div {
                    text-align: center;
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                
                .index { width: 60px; }
                .member_name { width: 100px; }
                .store_name { width: 150px; }
                .goods_name { 
                    flex: 1; 
                    min-width: 150px; 
                }
                .sccode { width: 120px; }
                .oecode { width: 120px; }
                .oenaturebrand { width: 100px; }
                .arrived_state { width: 90px; }
                .add_time { width: 160px; }
            }
            
            .no-data {
                text-align: center;
                padding: 50px 0;
                color: #999;
                font-size: 14px;
            }
        }
    }
    
    .pagination-box {
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        margin-top: 15px;
        text-align: right;
    }
}
</style>
